import { render, staticRenderFns } from "./FootballShotmap.vue?vue&type=template&id=68d82cc4&scoped=true&"
import script from "./FootballShotmap.vue?vue&type=script&lang=js&"
export * from "./FootballShotmap.vue?vue&type=script&lang=js&"
import style0 from "./FootballShotmap.vue?vue&type=style&index=0&id=68d82cc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d82cc4",
  null
  
)

export default component.exports